import Head from 'next/head';
import NavTabs from '@/components/NavTabs';

const navTabs = () => {
  return (
    <>
      <Head>
        <title>Nav-Tabs</title>
      </Head>

      <h1>Navigation Tabs</h1>

      <div className="row">
        <div className="col-12">
          <NavTabs />
        </div>
      </div>
    </>
  );
};

export default navTabs;
